import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news-detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <CategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "news-detail/:id", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;